import { useState } from "react";
import { Star, BadgeCheck } from "lucide-react";

const NEON = {
  fill: "#FFD600",
  color: "#FFD600",
  filter: "drop-shadow(0 0 5px rgba(255,214,0,0.95)) drop-shadow(0 0 14px rgba(255,180,0,0.55))",
};
const EMPTY = { fill: "transparent", color: "#A1A1AA" };

export const Stars = ({ value = 0, size = 18, testid = "stars" }) => (
  <div className="flex items-center gap-1" data-testid={testid} aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} strokeWidth={1.5} style={n <= Math.round(value) ? NEON : EMPTY} />
    ))}
  </div>
);

export const VerifiedBadge = () => (
  <span
    data-testid="verified-buyer-badge"
    className="inline-flex items-center gap-1 bg-[#00E5FF]/15 text-[#0E7490] border border-[#00E5FF]/50 px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.15em] whitespace-nowrap"
  >
    <BadgeCheck size={12} /> Verified buyer
  </span>
);

export const StarPicker = ({ value, onChange, size = 32, testid = "star-picker" }) => {
  const [hover, setHover] = useState(0);
  const active = hover || value;
  return (
    <div className="flex items-center gap-2" data-testid={testid} role="radiogroup" aria-label="Rating from 1 to 5 stars">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          data-testid={`${testid}-${n}`}
          onClick={() => onChange(n)}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          className="p-1 transition-transform duration-150 hover:scale-125 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD600]"
        >
          <Star size={size} strokeWidth={1.5} style={n <= active ? NEON : EMPTY} />
        </button>
      ))}
    </div>
  );
};
